module.exports = __webpack_public_path__ + "static/media/header.724c9be9.png";